// throttle.ts
export function throttle<T extends (...args: any[]) => void>(
    func: T,
    delay: number
): T {
    let isThrottled = false;
    let savedArgs: Parameters<T> | null = null;

    function wrapper(this: unknown, ...args: Parameters<T>) {
        // If we are throttled, save the latest arguments to call later.
        if (isThrottled) {
            savedArgs = args;
            return;
        }

        // Otherwise, call the function now.
        func(...args);
        isThrottled = true;

        // Set a timer to reset throttle and (if needed) call with saved arguments.
        setTimeout(() => {
            isThrottled = false;
            if (savedArgs) {
                wrapper(...savedArgs);
                savedArgs = null;
            }
        }, delay);
    }

    return wrapper as T;
}
